window.bm.MainViewModel = function (extraModelArray, currentPageView, handbookId) {
  var self = this;

  self.SearchViewParam = 'search';
  self.DefaultViewParam = 'default';

  self.HandbookId = ko.observable(handbookId);
  self.CurrentPageView = ko.observable(!currentPageView || currentPageView.length == 0 ? self.DefaultViewParam : currentPageView);

  //Word Cloud Module
  self.WordCloudAvailableEntities = [];
  self.WordCloudSectionVisible = ko.observable(false);
  self.WordCloudSelectedEntities = ko.observableArray([]);
  self.IsWordCloudSearching = ko.observable(false);
  self.WordCloudSetSelectedEntities = function (entityTagIds) {
    if (!!entityTagIds && entityTagIds.length > 0 && self.WordCloudAvailableEntities.length > 0) {
      var selectedEntities = [];
      ko.utils.arrayForEach(self.WordCloudAvailableEntities, function (item) {
        if (item.entityType == 'Topic' || item.entityType == 'SubTopic') {
          if (entityTagIds.indexOf(item.id) >= 0) {
            selectedEntities.push(item);
          } else {
            if (!!item.questions && item.questions().length > 0) {
              var mockChildEntity = new ChildEntity(null);
              var tempQuestions = ko.utils.arrayFilter(item.questions(), function (subItem) {
                return entityTagIds.indexOf(subItem.id) >= 0;
              });
              if (tempQuestions.length > 0) {
                mockChildEntity.name = item.name;
                mockChildEntity.questions(tempQuestions);
                selectedEntities.push(mockChildEntity);
              }
            }

            if (!!item.subTopics && item.subTopics().length > 0) {
              ko.utils.arrayForEach(item.subTopics(), function (subTopic) {
                if (entityTagIds.indexOf(subTopic.id) >= 0) {
                  selectedEntities.push(subTopic);
                } else {
                  if (!!subTopic.questions && subTopic.questions().length > 0) {
                    var mockChildEntity = new ChildEntity(null);
                    var tempQuestions = ko.utils.arrayFilter(subTopic.questions(), function (question) {
                      return entityTagIds.indexOf(question.id) >= 0;
                    });
                    if (tempQuestions.length > 0) {
                      mockChildEntity.name = subTopic.name;
                      mockChildEntity.parentName = item.name;
                      mockChildEntity.questions(tempQuestions);
                      selectedEntities.push(mockChildEntity);
                    }
                  }
                }
              });
            }
          }
        }
      });
      self.WordCloudSelectedEntities(selectedEntities);
    } else {
      self.WordCloudSelectedEntities([]);
    }
  };

  self.WordCloudSearch = function (entityIdsOverride, wordCloudItemId) {
    self.IsWordCloudSearching(true);
    if (self.WordCloudAvailableEntities.length > 0 && !!wordCloudItemId && wordCloudItemId.length > 0) {
      if (!!entityIdsOverride && entityIdsOverride.length > 0) {
        self.WordCloudSetSelectedEntities(entityIdsOverride);
      } else {
        $.ajax({
          url: '/api/wordcloud/phrasesearch',
          type: 'GET',
          mimeType: 'application/json',
          dataType: 'json',
          data: {
            wordcloudid: wordCloudItemId,
            handbookid: self.HandbookId()
          },
          global: false,
          error: function (xhr, statusText, errorText) {

          },
          success: function (data, requestData) {
            self.WordCloudSetSelectedEntities(data);
            self.IsWordCloudSearching(false);
          }
        });
      }
    }
  };

  self.SetWordCloudDetail = function (wordCloudId, shouldScroll) {
    if (!!wordCloudId && wordCloudId.length > 0) {
      var entityIdsArr = [];
      var $wordCloudElem = $('.cloud-item-js[data-wordcloud-id="' + wordCloudId + '"]');
      if (!!$wordCloudElem && $wordCloudElem.length > 0) {
        var entityIds = $wordCloudElem.data('entitytags');

        if (!!entityIds && entityIds.length > 0) {
          entityIdsArr = entityIds.split(',');
        }

        self.WordCloudSearch(entityIdsArr, wordCloudId);
      }

      self.WordCloudSectionVisible(true);

      if (shouldScroll) {
        var scrollPosition = Math.ceil($('.topic-grid').offset().top + $('.topic-grid').outerHeight());
        $("html, body").animate({ scrollTop: scrollPosition }, "slow");
      }
    } else {
      self.WordCloudSectionVisible(false);
    }
  };

  self.SetTopicDetail = function (topicId, subTopicId, questionId, shouldScroll) {
    var scrollPosition;
    if (!!self.ChapterPageViewModel && !!topicId && topicId.length > 0) {
      self.ChapterPageViewModel.CurrentSelectedTopicId = topicId;
      self.WordCloudSectionVisible(false);

      var hasSubTopic = !!subTopicId && subTopicId.length > 0;
      var $topicTile = $('.grid-item-js[data-topicid="' + topicId + '"]');

      if (!!$topicTile && $topicTile.length > 0) {

        ko.utils.arrayForEach(self.ChapterPageViewModel.CurrentChapter().topics(), function (item) {
          item.Selected(item.id == topicId);
          if (item.Selected()) {
            if (!hasSubTopic) {
              subTopicId = self.ChapterPageViewModel.SubTopicAllTabLabel.toLowerCase();
            }
            ko.utils.arrayForEach(item.subTopics(), function (subItem) {
              var isSelected = subItem.id == subTopicId || subTopicId.toLowerCase() == self.ChapterPageViewModel.SubTopicAllTabLabel.toLowerCase();
              subItem.Selected(isSelected);

              if (subItem.Selected() && !!questionId && questionId.length > 0) {
                ko.utils.arrayForEach(subItem.questions(), function (question) {
                  if (question.id == questionId) {
                    var $questionElem = $('.question[data-questionid="' + questionId + '"]');
                    scrollPosition = self.SetAccordionExpandCollapse($questionElem);
                  }
                });
              }
            });

            if (!!questionId && questionId.length > 0) {
              ko.utils.arrayForEach(item.questions(), function (question) {
                if (question.id == questionId) {
                  var $questionElem = $('.question[data-questionid="' + questionId + '"]');
                  scrollPosition = self.SetAccordionExpandCollapse($questionElem);
                }
              });
            }

            var $subTopicTab = $('.sub-topic-tab[data-tabid="' + subTopicId + '"]');
            if (!$subTopicTab.hasClass('active-tab')) {
              $subTopicTab.parent().find('.active-tab').removeClass('active-tab');
              $subTopicTab.addClass('active-tab');
              self.ChapterPageViewModel.CurrentSubTopicTabName($subTopicTab.html());
            }
          }
        });

        $topicTile.parent().find('.active').removeClass('active');
        $topicTile.find('.topic-container').addClass('active');
      }

      if (scrollPosition == null || scroll == undefined) {
        if (hasSubTopic) {
          scrollPosition = Math.ceil($('.sub-topics-container').offset().top + 20);
        } else {
          scrollPosition = Math.ceil($('.topic-grid').offset().top + $('.topic-grid').outerHeight());
        }
      }

      if (shouldScroll && !!scrollPosition) {
        $("html, body").animate({ scrollTop: scrollPosition }, "slow");
      }
    }
  };
  self.SetAccordionExpandCollapse = function ($accordion) {
    if ($accordion.hasClass('expanded')) {
      $accordion.removeClass('expanded');
    } else {
      $('.question.expanded').removeClass('expanded');
      $accordion.addClass('expanded');
    }

    return $accordion.offset().top - 20;
  };

  self.Load = function () {
    var qsParms = self.parseQueryString(window.location.href);
    if (!!qsParms) {
      if (!!qsParms.scroll && qsParms.scroll.length > 0) {
        scrollPosition = parseInt(qsParms.scroll);
      }
      if (!!qsParms.topic && qsParms.topic.length > 0) {
        setTimeout(function () {
          self.SetTopicDetail(qsParms.topic, qsParms.subtopic, qsParms.question, true);
        }, 100);
      } else if (!!qsParms.wordcloudid && qsParms.wordcloudid.length > 0) {
        setTimeout(function () {
          self.SetWordCloudDetail(qsParms.wordcloudid, true);
        }, 100);
      }
    }
  }

  self.parseQueryString = function (str) {
    if (typeof str !== 'string') {
      return {};
    }
    var strArr = str.trim().split('?');

    if (!strArr || strArr.length < 2) {
      return {};
    }
    str = strArr[1];
    return str.trim().split('&').reduce(function (ret, param) {
      var parts = param.replace(/\+/g, ' ').split('=');
      ret[parts[0]] = parts[1] === undefined ? null : decodeURIComponent(parts[1]);
      return ret;
    }, {});
  };


  if (typeof (extraModelArray) != "undefined") {
    for (var i = 0; i < extraModelArray.length; i++) {
      var model = extraModelArray[i];
      self[model.Name] = model;
    }
  }


  self.Load();
};
ko.bindingHandlers.OnWindowStateChanged = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    // Onstate change for history
    window.onstatechange = function () {
      var qs = History.getState().data['qs'];
      if (!!qs) {
        var qsParms = bindingContext.$root.parseQueryString(qs);
        var currentView = qsParms.view;
        if (!currentView || currentView.length == 0) {
          currentView = bindingContext.$root.DefaultViewParam;
        }

        if (currentView == bindingContext.$root.SearchViewParam) {
          var currentSkip = bindingContext.$root.HandbookSearchViewModel.HandbookSearchResultData().searchResults().length;
          var newSkip = 0;
          if (!!qsParms.skip && qsParms.skip > 0) {
            newSkip = parseInt(qsParms.skip);
          }
          var projectedTotal = newSkip + bindingContext.$root.HandbookSearchViewModel.HandbookSearchResultData().searchFilters.take;
          if (projectedTotal < currentSkip && newSkip != 0) {
            // This is here for a back button after a page scroll
            bindingContext.$root.HandbookSearchViewModel.IsSearchRunning(true);
            bindingContext.$root.HandbookSearchViewModel.HandbookSearchResultData().hasMoreResults(true);
            bindingContext.$root.HandbookSearchViewModel.HandbookSearchResultData().searchFilters.skip(newSkip);
            while (bindingContext.$root.HandbookSearchViewModel.HandbookSearchResultData().searchResults().length > projectedTotal) {
              var popped = bindingContext.$root.HandbookSearchViewModel.HandbookSearchResultData().searchResults.pop();
            }
            bindingContext.$root.HandbookSearchViewModel.IsSearchRunning(false);
          } else {
            var hasFilters = false;
            if (!!qsParms.keyword && qsParms.keyword.length > 0) {
              bindingContext.$root.HandbookSearchViewModel.HandbookSearchResultData().searchFilters.query(qsParms.keyword);
              hasFilters = true;
            }
            bindingContext.$root.HandbookSearchViewModel.HandbookSearchResultData().searchFilters.skip(newSkip);
            bindingContext.$root.HandbookSearchViewModel.LoadDataFromServer();
          }
        } else if (currentView == bindingContext.$root.DefaultViewParam) {
          if (!!qsParms.wordcloudid && qsParms.wordcloudid.length > 0) {
            bindingContext.$root.SetWordCloudDetail(qsParms.wordcloudid, false);
          } else {
            bindingContext.$root.WordCloudSectionVisible(false);
          }

          if (!!qsParms.topic && qsParms.topic.length > 0 && !!bindingContext.$root.ChapterPageViewModel) {
            bindingContext.$root.SetTopicDetail(qsParms.topic, qsParms.subtopic, qsParms.question, false);
          } else if (!!bindingContext.$root.ChapterPageViewModel) {
            ko.utils.arrayForEach(bindingContext.$root.ChapterPageViewModel.CurrentChapter().topics(), function (item) {
              item.Selected(false);
            });
            $('.topic-container.active').removeClass('active');
          }
        }


        bindingContext.$root.CurrentPageView(currentView);

        // Reposition by scoll position
        var scrollPosition = 0;
        if (!!qsParms.scroll && qsParms.scroll.length > 0) {
          scrollPosition = parseInt(qsParms.scroll);
        }
        $("html, body").animate({ scrollTop: scrollPosition }, "slow");
      }
      return;
    }
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

  }
};
ko.bindingHandlers.WordCloudSearchTrigger = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var availableEntities = [];

    if (!!bindingContext.$root.ChapterPageViewModel && !!bindingContext.$root.ChapterPageViewModel.CurrentChapter()) {
      availableEntities = bindingContext.$root.ChapterPageViewModel.CurrentChapter().topics();
    }

    bindingContext.$root.WordCloudAvailableEntities = availableEntities;
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    $(element).on('click', function (ev) {
      ev.preventDefault();

      var dataId = $(this).data('wordcloud-id');

      if (!!dataId && dataId.length > 0) {
        var scrollPosition = Math.ceil($('.topic-grid').offset().top + $('.topic-grid').outerHeight());
        var qs = "?wordcloudid=" + dataId + "&scroll=" + scrollPosition;

        History.pushState({ qs: qs }, History.options.initialTitle, qs);
      }

      $(element).blur();

    });
  }
};
ko.bindingHandlers.SwitchContentView = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var currentPageView = ko.utils.unwrapObservable(valueAccessor()).toLowerCase();
    var $siteSearchSection = $('#SearchSection');
    var $defaultSection = $('#DefaultSection');

    setTimeout(function () {
      if (currentPageView == bindingContext.$root.SearchViewParam) {
        $defaultSection.removeClass('active-section').animate({ "opacity": "0" }, 600);
        $siteSearchSection.addClass('active-section').animate({ "opacity": "1" }, 600);
      } else if (currentPageView == '' || currentPageView == bindingContext.$root.DefaultViewParam) {
        $siteSearchSection.removeClass('active-section').animate({ "opactiy": "0" }, 600);
        $defaultSection.addClass('active-section').animate({ "opacity": "1" }, 600);
      }
    }, 300);

  }
};
ko.bindingHandlers.BindDropDownTrigger = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    $(element).on('click', function (ev) {
      ev.preventDefault();
      $('#GlossaryModal').removeClass('active').removeClass('active-freeze').fadeOut(300);
      var $dropdownContainer = $(this).parent().parent().find('.js-drop-down-container');

      if (!!$dropdownContainer && $dropdownContainer.length > 0) {
        if ($(this).hasClass('expanded')) {
          $dropdownContainer.removeClass('active');
          $(this).removeClass('expanded');
        } else {
          $dropdownContainer.addClass('active');
          $(this).addClass('expanded');

          setTimeout(function () {
            BodyClickCloseDropDown($dropdownContainer, $(element));
          }, 100);

          $dropdownContainer.find('li').on('click', function () {
            setTimeout(function () {
              $('body').trigger('click');
            }, 100);
          });
        }

      }
    });

  }
};
function BodyClickCloseDropDown($dropdownContainer, $triggerElement) {
  $('body').one('click', function (ev) {
    if (!$dropdownContainer.is(ev.target) && $dropdownContainer.has(ev.target).length === 0) {
      $dropdownContainer.removeClass('active');
      $triggerElement.removeClass('expanded');
    } else {
      BodyClickCloseDropDown($dropdownContainer, $triggerElement);
    }
  });

}

var animationTime = 700;
var defaultAnimation = {
  duration: 1000,
  translateY: 400,
  opacity: {
    value: [0, 1],
    duration: animationTime,
    easing: 'linear'
  },
  translateY: {
    value: [200, 0],
    duration: animationTime,
    elasticity: 400,
    easing: 'easeInOutBack'
  },
};

ko.bindingHandlers.BindGridAnimation = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    if ($(element).parent().hasClass('animation-initialized')) {
      var animation = defaultAnimation;
      animation.targets = element;
      anime(defaultAnimation);
    }
  }
};
ko.bindingHandlers.BindRichTextContentTransform = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    window.ExternalLinksNewWindow($(element));
    if (!!window.bm.InitGlossaryTermsModule) {
      window.bm.InitGlossaryTermsModule($(element));
    }
  }
};